import type { QualityList } from '@/api/reportApi'

// 提交时必须上传的资质图片类型，按平台编码配置
const REQUIRED_QUALITY_TYPES: Record<string, string[]> = {
  // 南水北调：商品详情接口要返回品牌授权信息的图片
  WZ1863: ['18'],
}

// 计算所选平台缺失的必传资质图片类型（返回类型编码）
export function getMissingQualityTypes(
  platformCodes: string[],
  qualityDataList: QualityList[] = [],
): string[] {
  const uploaded = qualityDataList.map((item) => item.sourceType)
  return platformCodes
    .reduce<string[]>(
      (types, code) => types.concat(REQUIRED_QUALITY_TYPES[code] ?? []),
      [],
    )
    .filter((type, index, types) => types.indexOf(type) === index)
    .filter((type) => !uploaded.includes(type))
}
import type { QualityList } from '@/api/reportApi'

// 提交时必须上传的资质图片类型，按平台编码配置
const REQUIRED_QUALITY_TYPES: Record<string, string[]> = {
  // 南水北调：商品详情接口要返回品牌授权信息的图片
  WZ1863: ['18'],
}

// 计算所选平台缺失的必传资质图片类型（返回类型编码）
export function getMissingQualityTypes(
  platformCodes: string[],
  qualityDataList: QualityList[] = [],
): string[] {
  const uploaded = qualityDataList.map((item) => item.sourceType)
  return platformCodes
    .reduce<string[]>(
      (types, code) => types.concat(REQUIRED_QUALITY_TYPES[code] ?? []),
      [],
    )
    .filter((type, index, types) => types.indexOf(type) === index)
    .filter((type) => !uploaded.includes(type))
}
